import type { Descendant, Text } from "slate";

const headingTypes = ["heading-one", "heading-two"] as const;
const listTypes = ["bulleted-list", "numbered-list"] as const;
const alignTypes = ["left", "center", "right", "justify"] as const;

type HeadingType = (typeof headingTypes)[number];
type ListType = (typeof listTypes)[number];
type ElementAlign = (typeof alignTypes)[number];

export type BlockButtonType =
    | HeadingType
    | ListType
    | "block-quote"
    | ElementAlign;

export type ParagraphElementType =
    | HeadingType
    | ListType
    | "block-quote"
    | "paragraph"
    | "list-item";

export interface ParagraphElement {
    type: ParagraphElementType;
    align?: ElementAlign;
    children: Descendant[];
}

export interface ImageElement {
    type: "image";
    src: string;
    children: Text[];
}

export interface LinkElement {
    type: "link";
    url: string;
    children: Descendant[];
}

export interface TableElement {
    type: "table";
    children: TableRowElement[];
}

export interface TableRowElement {
    type: "table-row";
    children: TableCellElement[];
}

export interface TableCellElement {
    type: "table-cell";
    children: Descendant[];
}

export type CustomElement =
    | ParagraphElement
    | ImageElement
    | LinkElement
    | TableElement
    | TableRowElement
    | TableCellElement;

export type ElementType = CustomElement["type"];

export interface CustomText {
    text: string;
    bold?: true;
    italic?: true;
    underline?: true;
    strikethrough?: true;
    code?: true;
}

export function isAlignType(
    type: BlockButtonType | ElementType,
): type is ElementAlign {
    return (alignTypes as readonly string[]).includes(type);
}

export function isListType(
    type: BlockButtonType | ElementType,
): type is ListType {
    return (listTypes as readonly string[]).includes(type);
}
